// extracted by mini-css-extract-plugin
export default {"giftify":"Giftify_giftify__xOHip"};